import './interventionReports.css';
import { Trans, useTranslation } from 'react-i18next';
import FilterIcon from '../../assets/filter.png';
import ModalComponent from '../../component/modal/modal';
import { FC, useMemo, useState } from 'react';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import {
  InterventionReportAdvancedFilters,
  InterventionReportsTableFilterProps,
} from './interventionReports.type';
import FilterPanel from '../../component/filterPanel/filterPanel';
import { getInterventionReportFilterFields } from './interventionReportsFilterHelper';

export const InterventionReportsTableFilter: FC<
  InterventionReportsTableFilterProps
> = (props) => {
  const { isTablet } = useResponsiveLayout();
  const { t } = useTranslation();
  const [draftFilterValues, setDraftFilterValues] = useState<
    Record<string, unknown>
  >(props.currentFilters as Record<string, unknown>);

  const filterFields = useMemo(
    () => getInterventionReportFilterFields(props.reports ?? [], t),
    [props.reports, t],
  );

  const handleFieldChange = (key: string, value: unknown): void => {
    setDraftFilterValues((prev: Record<string, unknown>) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleApplyClick = (): void => {
    const { dateCreatedFrom, dateCreatedTo, ...advancedFilters } =
      draftFilterValues;
    const newDateRange = dateCreatedFrom
      ? {
          from: dateCreatedFrom as Date,
          to: (dateCreatedTo as Date) ?? (dateCreatedFrom as Date),
        }
      : undefined;
    props.handleApplyFilters(
      advancedFilters as InterventionReportAdvancedFilters,
      newDateRange,
    );
  };

  const handleClearClick = (): void => {
    setDraftFilterValues({});
    props.handleClearFilters();
  };

  const handlePanelOpen = (): void => {
    setDraftFilterValues({
      ...(props.currentFilters as Record<string, unknown>),
      dateCreatedFrom: props.currentDateRange?.from,
      dateCreatedTo: props.currentDateRange?.to,
    });
    props.toggleFilterModal(true);
  };

  return (
    <>
      <div
        onClick={handlePanelOpen}
        className="filter-container mr-3  mt-1 relative inline-block cursor-pointer"
      >
        <img src={FilterIcon} alt="Filters" className="w-3 h-3" />
        {props.hasActiveFilters && (
          <button
            type="button"
            onClick={(event: React.MouseEvent) => {
              event.stopPropagation();
              handleClearClick();
            }}
            className="absolute -top-0 -right-2 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center cursor-pointer"
          >
            <span className="text-white text-[0.5rem] font-bold">✕</span>
          </button>
        )}
      </div>
      <ModalComponent
        open={props.isOpenUserModal}
        shouldCloseOnOutsideClick={false}
        enforceFocus={false}
        onToggle={() => {}}
        onFooterButton1Click={handleClearClick}
        onFooterButton2Click={handleApplyClick}
        dialogClassName="w-modal-md"
        title={<Trans i18nKey="userManagement.userFilter.filter" />}
        footerButton1Text={
          <Trans i18nKey="userManagement.userFilter.clearAll" />
        }
        footerButton2Text={<Trans i18nKey="userManagement.userFilter.apply" />}
        onClose={() => props.toggleFilterModal(false)}
        showFooter2Button
        showFooter1Button
        isShowClose
        footerButton1WrapperStyle={isTablet ? 'w-[300px]' : ''}
        footerButton2WrapperStyle={isTablet ? 'w-[300px]' : ''}
      >
        <FilterPanel
          fields={filterFields}
          values={draftFilterValues}
          onChange={handleFieldChange}
        />
      </ModalComponent>
    </>
  );
};
